<template>
  <div>
    <!-- PAGE HEADER -->
    <page-header
      title="Contact us."
      subtitle="We’d love to hear from you!"
      bgImage="/img/headers/contact-header.webp"
    />

    <!-- CONTACT INFO -->
    <section class="my-6">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 text-center mb-5">
            <section-header
              title="How can we help you?"
              subtitle="We're here for you"
            />Whether you need help using the Art Grab website, or have
            questions about the artwork, we’re here to help. Feel free to reach
            out to us at any time and we’ll be happy to answer your questions.
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="contact-card">
              <h2><i class="fas fa-envelope"></i> EMAIL</h2>
              <div class="email-link">
                <a href="mailto:contact@artgrab.co">contact@artgrab.co</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4 text-center">
          <div class="col-12">
            And be sure to follow us on
            <a href="https://instagram.com/artgrab.co" target="_blank"
              >Instagram</a
            >,
            <a href="https://www.facebook.com/artgrab.co" target="_blank"
              >Facebook</a
            >
            and
            <a href="https://x.com/ArtgrabCo" target="_blank">X</a>
            for all of the latest Art Grab updates.
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ CTA -->
    <call-to-action-section
      text="Have questions about how you can use licensed artwork? Check out our FAQ."
    >
      <router-link to="/about" class="btn btn-secondary"
        >FREQUENTLY ASKED QUESTIONS</router-link
      >
    </call-to-action-section>

    <!-- NEWSLETTER SIGNUP -->
    <newsletter-signup bg-image="/img/headers/newsletter-bg-2.jpg" />
  </div>
</template>

<script>
import {
  PageHeader,
  SectionHeader,
  NewsletterSignup,
  CallToActionSection,
} from "../../components";
const artgrabURL = process.env.VUE_APP_ARTGRAB_URL;

export default {
  name: "contact-page",
  metaInfo() {
    return {
      title: "Contact Us - Art Grab",
      meta: [
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: `summary_large_image`,
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: `Contact Us - Art Grab`,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: `Have questions? Feel free to reach out to us at any time and we’ll be happy to help.`,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: "https://artgrab.co/img/headers/contact-header.webp",
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `https://artgrab.co/contact`,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: `Contact Us - Art Grab`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: `Have questions? Feel free to reach out to us at any time and we’ll be happy to help.`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: "https://artgrab.co/img/headers/contact-header.webp",
        },
        {
          vmid: "description",
          property: "description",
          content: `Have questions? Feel free to reach out to us at any time and we’ll be happy to help.`,
        },
      ],
      link: [{ rel: "canonical", href: `${artgrabURL}/contact` }],
    };
  },
  components: {
    PageHeader,
    SectionHeader,
    NewsletterSignup,
    CallToActionSection,
  },
  mounted() {
    this.$store.commit("setLayout", "page-layout");
  },
};
</script>

<style lang="scss" scoped>
.contact-card {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 225px;
  margin-bottom: 2rem;

  .email-link {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 2rem;
  }
}
</style>
